import { render, staticRenderFns } from "./mode_switch1.vue?vue&type=template&id=804be35c&scoped=true&"
import script from "./mode_switch1.vue?vue&type=script&lang=js&"
export * from "./mode_switch1.vue?vue&type=script&lang=js&"
import style0 from "./mode_switch1.vue?vue&type=style&index=0&id=804be35c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "804be35c",
  null
  
)

export default component.exports